import {
  TravelExpensesComment,
  TravelExpensesCommentInput
} from '../../../lib/types/models/travel-expenses/travel-expenses-comment'
import { UpdateInput } from '../../../lib/types/utils'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const updateTravelExpensesComment = async (
  data: UpdateInput<TravelExpensesCommentInput> & { affectedStaffId: number }
) => {
  const { id, affectedStaffId, ...rest } = data
  return restApiClient
    .url(
      constructApiUrl(API.affectedStaffs.updateTravelExpensesComment.url, { id, affectedStaffId })
    )
    .patch<TravelExpensesComment, Partial<TravelExpensesCommentInput>>(rest)
}
